// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IFogResource {
  format_version?: string;
}
